import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map, catchError, first } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { User } from '@app/_models';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    private currentTokenSubject: BehaviorSubject<String>;
    public currentToken: Observable<String>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
        this.currentTokenSubject = new BehaviorSubject<String>(sessionStorage.getItem('currentToken'));
        this.currentToken = this.currentTokenSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    public get currentTokenValue(): String {
        return this.currentTokenSubject.value;
    }

    login(username: string, password: string) {
        
        return this.http.post<any>(`${environment.apiUrl}/authentication/authenticate`, { username, password })
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
                return user;
            }), catchError( er => {
                console.log("error  " + er);
                return throwError(er);
            }));
    }

    logout() {
        console.log("logout");
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
        sessionStorage.clear();
    }

    validateToken(token: string) {
        return this.http.post<any>(`${environment.apiUrl}/authentication/validatetoken`, { token })
            .pipe(map(result => {
                if (result.isValid)
                {
                    sessionStorage.setItem('currentToken', token);
                    this.currentTokenSubject.next(token);
                }
                return result;
            }), catchError( er => {
                console.log("error  " + er);
                return er;
            }));
    }

    finishOnboarding() {
        let user = this.currentUserValue;
        user.onboardComplete = true;
        localStorage.setItem('currentUser', JSON.stringify(user));
    }

    validateResetPasswordToken(token: string) {
        return this.http.post<any>(`${environment.apiUrl}/authentication/validate-reset-token`, { token })
            .pipe(map(result => {
                return result;
            }), catchError( er => {
                console.log("error  " + er);
                return er;
            }));
    }

    createUserPassword(passwordForm: any) {
        return this.http.post<any>(`${environment.apiUrl}/authentication/setuserpassword`, 
        {
            newPassword: passwordForm.newPassword,
            newPasswordRepeat: passwordForm.newPasswordRepeat,
            token: this.currentTokenSubject.value
        })
        .pipe(map(result => {
            return result;
        }), catchError( er => {
            console.log("error  " + er);
            return er;
        }));
    }

    resetUserPassword(passwordForm: any) {
        return this.http.post<any>(`${environment.apiUrl}/authentication/resetuserpassword`, 
        {
            newPassword: passwordForm.newPassword,
            newPasswordRepeat: passwordForm.newPasswordRepeat,
            token: passwordForm.token
        })
        .pipe(map(result => {
            return result;
        }), catchError( er => {
            console.log("error  " + er);
            return er;
        }));
    }

    forgotPassword(email: string) {
        return this.http.post<any>(`${environment.apiUrl}/authentication/forgot-password`, 
        {
            email: email
        })
        .pipe(map(result => {
            return result;
        }), catchError( er => {
            console.log("error  " + er);
            return er;
        }));
    }
}